module.exports = __webpack_public_path__ + "assets/ErrorParrot.08ae625e.svg";